import { render, staticRenderFns } from "./TeethMap.vue?vue&type=template&id=852c9c8a&"
import script from "./TeethMap.vue?vue&type=script&lang=js&"
export * from "./TeethMap.vue?vue&type=script&lang=js&"
import style0 from "./TeethMap.vue?vue&type=style&index=0&id=852c9c8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports